
// event if click on socials link then trigger exit_click
document.querySelectorAll('.social-icons a').forEach(link => {
    link.addEventListener('click', function () {
      console.log('exit_click');
  
     // If you're using GTM or want to push this event to dataLayer:
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'exit_click',
          link_url: 'social icons'
        });
    });
  });

// event if click on country popup location and language
  // Trigger 'location' when clicking on country name
  document.querySelectorAll('.countries_list_url').forEach(link => {
    link.addEventListener('click', function () {
      const countryName = this.innerText.trim();
      console.log('location');
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'location',
        location_name: countryName
      });
    });
  });
  
  // Trigger 'language' when clicking on specific language options
  document.querySelectorAll('.countries_list_languages_url').forEach(link => {
    link.addEventListener('click', function () {
      const languageName = this.innerText.trim();
      console.log('language');  
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'language',
        language_name: languageName
      });
    });
  });


// event if click on menu then click_menu will trigger
    // Track submenu item clicks
    document.querySelectorAll('.site-nav-container a.menu-link').forEach(link => {
      link.addEventListener('click', function () {
        const label = this.innerText.trim();
        console.log('click_menu (click):', label);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'click_menu',
          menu_label: label,
          interaction: 'click'
        });
      });
    });
    // Track top-level menu hovers
    document.querySelectorAll('.site-nav-container li.has-submenu').forEach(item => {
      item.addEventListener('mouseenter', function () {
        const label = this.querySelector('a.menu-link')?.innerText.trim();
        if (label) {
          console.log('click_menu (hover):', label);
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'click_menu',
            menu_label: label,
            interaction: 'hover'
          });
        }
      });
    });

// event if filter is selected on collection page
    function fireSelectFilter(type, value) {
      console.log('select_filter:', type, '→', value);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'select_filter',
        filter_type: type,
        filter_value: value
      });
    }
    // --- User interacts with Sort By dropdown ---
    document.querySelector('#desktop-SortBy')?.addEventListener('change', function () {
      const selectedValue = this.options[this.selectedIndex].text.trim();
      fireSelectFilter('Sort by', selectedValue);
    });
    // --- User checks/unchecks Availability filter ---
    document.querySelectorAll('input[name="filter.v.availability"]').forEach(checkbox => {
      checkbox.addEventListener('change', function () {
        const label = this.closest('label')?.innerText.trim();
        fireSelectFilter('Availability', label);
      });
    });    
    // --- User inputs price range manually ---
    ['input[name="filter.v.price.gte"]', 'input[name="filter.v.price.lte"]'].forEach(selector => {
      document.querySelector(selector)?.addEventListener('blur', () => {
        const min = document.querySelector('input[name="filter.v.price.gte"]').value || '0';
        const max = document.querySelector('input[name="filter.v.price.lte"]').value || 'max';
        const range = `$${min} - $${max}`;
        fireSelectFilter('Price', range);
      });
    });

// event Fired when the webpage is in focus for at least 10 seconds.
   let engagementTimer;
   let engagementFired = false;
    function fireUserEngagementEvent() {
      if (engagementFired) return; // Only fire once
      engagementFired = true;    
      console.log('user_engagement');
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'user_engagement'
      });
    } 
    function startEngagementTimer() {
      if (!engagementTimer && !engagementFired) {
        engagementTimer = setTimeout(fireUserEngagementEvent, 10000); // 10 seconds
      }
    }
    function clearEngagementTimer() {
      clearTimeout(engagementTimer);
      engagementTimer = null;
    }
    // Start tracking when page is focused
    window.addEventListener('focus', startEngagementTimer);
    // Stop tracking when user leaves the tab
    window.addEventListener('blur', clearEngagementTimer);    
    // Optional: Handle case where tab is already focused on load
    if (document.hasFocus()) {
      startEngagementTimer();
    }

// event Fired the first time a user visits a website with Analytics enabled
    // Check if this is the user's first visit
    if (!localStorage.getItem('has_visited')) {
        console.log('first_visit');  
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'first_visit'
        });
      // Mark that the user has now visited
      localStorage.setItem('has_visited', 'true');
    }

// event for video start, video complete, video progress
    function pushToDataLayer(eventName, extra = {}) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: eventName, ...extra });
      console.log(`✅ ${eventName} pushed`, extra);
    }

    // YouTube Tracking
    function initYouTubeTracking(iframe) {
      const player = new YT.Player(iframe, {
        events: {
          'onStateChange': function (event) {
            const states = {
              0: 'video_complete',
              1: 'video_start', // playing
              2: 'video_pause'
            };
    
            const eventName = states[event.data];
            if (eventName === 'video_start' || eventName === 'video_complete') {
              pushToDataLayer(eventName, { videoSrc: iframe.src });
            }
          }
        }
      });
    }

    // Vimeo Tracking
    function initVimeoTracking(iframe) {
      console.log('⏺ Binding Vimeo Events');
      const player = new Vimeo.Player(iframe);
      const progressFlags = { _25: false, _50: false, _75: false };
      player.on('play', () => {
        pushToDataLayer('video_start', { videoSrc: iframe.src });
      });
      player.on('ended', () => {
        pushToDataLayer('video_complete', { videoSrc: iframe.src });
      });
      player.on('timeupdate', function (data) {
        const percent = data.percent * 100;
        if (percent >= 25 && !progressFlags._25) {
          progressFlags._25 = true;
          pushToDataLayer('video_progress', { progress: '25%', videoSrc: iframe.src });
        }
        if (percent >= 50 && !progressFlags._50) {
          progressFlags._50 = true;
          pushToDataLayer('video_progress', { progress: '50%', videoSrc: iframe.src });
        }
        if (percent >= 75 && !progressFlags._75) {
          progressFlags._75 = true;
          pushToDataLayer('video_progress', { progress: '75%', videoSrc: iframe.src });
        }
      });
    }

    // Wait for DOM Ready
    document.addEventListener('DOMContentLoaded', () => {
      const videoPopups = document.querySelectorAll('.video-popup');
      videoPopups.forEach(popup => {
        const link = popup.querySelector('[data-js-video-popup-link]');
        const template = popup.querySelector('template');
        const container = popup.querySelector('[data-js-video-popup-container]');    
        if (!link || !template || !container) return;
        link.addEventListener('click', function (e) {
          e.preventDefault();    
          // Only inject iframe once
          if (container.innerHTML.trim() === '') {
            container.innerHTML = template.innerHTML;
          }
          setTimeout(() => {
            const iframe = container.querySelector('iframe');
            if (!iframe) return;    
            if (iframe.classList.contains('js-vimeo')) {
              if (typeof Vimeo === 'undefined') {
                const script = document.createElement('script');
                script.src = 'https://player.vimeo.com/api/player.js';
                script.onload = () => initVimeoTracking(iframe);
                document.head.appendChild(script);
              } else {
                initVimeoTracking(iframe);
              }
            } else if (iframe.classList.contains('js-youtube')) {
              if (typeof YT === 'undefined' || typeof YT.Player === 'undefined') {
                const tag = document.createElement('script');
                tag.src = "https://www.youtube.com/iframe_api";
                window.onYouTubeIframeAPIReady = () => initYouTubeTracking(iframe);
                document.head.appendChild(tag);
              } else {
                initYouTubeTracking(iframe);
              }
            }
          }, 300);
        });
      });
    });


// reset password form submit event 
 document.addEventListener('DOMContentLoaded', function () {
    setTimeout(() => {
      const resetForm = document.querySelector('form[action="/account/reset"]');      
      if (resetForm) {
        resetForm.addEventListener('submit', function () {
          localStorage.setItem('from_password_reset', 'true');
        });
      } else {
        console.log("Reset form NOT found on page load.");
      }
    }, 1000); 

    const fromReset = localStorage.getItem('from_password_reset');
    if (fromReset === 'true') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'forgot_password_login'
      });
      localStorage.removeItem('from_password_reset');
    }
  });


// event when user logged out
  document.addEventListener("DOMContentLoaded", function () {
    const logoutLink = document.querySelector('a[href="/account/logout"]');
    if (logoutLink) {
      logoutLink.addEventListener("click", function () {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "logout"
        });
        console.log("🔒 Logout event triggered via link");
      });
    }
  });
 





